<template>
  <v-layout>
    <v-flex shrink>
      <v-card width="250px" class="elevation-5 mb-3">
        <v-list class="py-0" style="background-color: #000">
          <v-list-tile>
            <v-list-tile-title
              style="text-align: center; font-size: 20px; color: white"
              >REPORT
              {{
                $store.state.backOffice.province.toUpperCase() || ""
              }}</v-list-tile-title
            >
          </v-list-tile>
        </v-list>
        <v-list dark class="py-0" style="background-color: #424242">
          <v-list-tile
            v-for="item in menuItems"
            :key="item.title"
            :to="item.link"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="white--text">{{
              item.title
            }}</v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-list
          dark
          class="py-0"
          style="overflow: hidden; background-color: #424242"
        >
          <v-list-group
            v-for="item in filteredSidebar"
            v-model="item.active"
            :key="item.title"
            :prepend-icon="item.action"
            no-action
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile
              v-for="subItem in filterSubSidebar(item)"
              :key="subItem.title"
              :to="subItem.url"
            >
              <v-list-tile-content>
                <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action v-if="subItem.alert">
                <v-btn
                  fab
                  color="primary"
                  style="height: 25px; width: 25px"
                  class="black--text"
                ></v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      items: [
        {
          action: "description",
          title: "Summary report",
          permission_name: "summary",
          items: [
            {
              permission_name: "order_report",
              title: "Order report",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/report/order_report",
            },
            {
              permission_name: "promotion_report",
              title: "Promotion report",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/report/promotion_report",
            },
            {
              permission_name: "customer_report",
              title: "Customer report",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/report/customer_report",
            },
          ],
        },
        {
          permission_name: "free_food",
          action: "fastfood",
          title: "Delivery",
          items: [
            {
              permission_name: "store_report",
              title: "Sale store report",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/report/store_report",
            },
            {
              permission_name: "store_payment",
              title: "Store payment report",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/report/store_payment",
            },
          ],
        },
        {
          permission_name: "messenger",
          action: "local_shipping",
          title: "Messenger",
          items: [
            {
              permission_name: "sale_messenger",
              title: "Sale messenger report",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/report/sale_messenger_report",
            },
          ],
        },
        {
          permission_name: "rider",
          action: "directions_bike",
          title: "Rider",
          items: [
            {
              permission_name: "rider_user_report",
              title: "Rider report",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/report/rider_report",
            },
            {
              permission_name: "extra_credit_report",
              title: "Extra credit zone report",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/report/extra_credit_zone_report",
            },
          ],
        },
        {
          permission_name: "order_receipt",
          action: "receipt",
          title: "Order receipt",
          items: [
            {
              permission_name: "food_delivery_receipt",
              title: "Food delivery receipt",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/report/order_report_food",
            },
            {
              permission_name: "free_delivery_receipt",
              title: "Free delivery receipt",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/report/order_report_free",
            },
            {
              permission_name: "messenger_receipt",
              title: "Messenger receipt",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/report/order_report_messenger",
            },
          ],
        },
      ],
      menuItems: [
        {
          icon: "assessment",
          title: "Dashboard",
          link:
            "/weserve_admin_login/control/" +
            this.$store.state.backOffice.province +
            "/report/main_dashboard",
        },
      ],
    };
  },
  methods: {
    filterSubSidebar(item) {
      return item.items.filter((val) => {
        for (let val2 in this.permission.report[item.permission_name]) {
          if (val2 == val.permission_name) return val;
        }
      });
      // return item.items;
    },
  },
  computed: {
    ...mapState({
      selectedMenu: (state) => state.backOffice.selectedMenu,
      permission: (state) => state.permission,
    }),
    filteredSidebar() {
      return this.items.filter(
        (val) => val.permission_name in this.permission.report
      );
    },
    filteredMainPage() {
      if (Object.keys(this.permission.report).length == 0) {
        return [];
      } else {
        return this.menuItems;
      }
    },
  },
};
</script>

